<template class="max">
  <div class="modal-body">
    <img class="logo" src="@/assets/img/logo.png" />
    <img class="image" src="@/assets/img/verify-envelope.svg" />
    <p class="title">Email verification!</p>

    <div class="text">
      Kindly input the 6 digits OTP that was sent to your email.
    </div>

    <v-otp-input
      style="margin-top: 20px"
      ref="otpInput"
      input-classes="otp-input"
      separator="-"
      :num-inputs="6"
      :should-auto-focus="true"
      :is-input-num="true"
      @on-change="handleOnChange"
      @on-complete="handleOnComplete"
    />

    <div class="submit">
      <div v-if="isDisabled">
        <button v-if="submitLoader" class="submit-button" disabled style="cursor: not-allowed; opacity: 0.7;">
          <div class="submit-gif">
            <div
              class="spinner-border"
              style="width: 2rem; height: 2rem"
              role="status"
            >
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </button>

        <button v-else class="submit-button" @click="submitOTP" type="button" :disabled="resendLoader" :style="resendLoader ? 'cursor: not-allowed; opacity: 0.5;' : ''">
          Submit OTP
        </button>
      </div>

      <button v-if="resendLoader" class="submit-button" disabled style="cursor: not-allowed; opacity: 0.7;">
        <div class="submit-gif">
          <div
            class="spinner-border"
            style="width: 2rem; height: 2rem"
            role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </button>

      <button v-else class="submit-button" @click="resendOTP" type="button" :disabled="submitLoader" :style="submitLoader ? 'cursor: not-allowed; opacity: 0.5;' : ''">
        Resend OTP
      </button>
    </div>
  </div>
</template>

<script>
import router from "../../router";

export default {
  name: "verify-email",
  data() {
    return {
      OTP: {},
      data: {},
      submitLoader: false,
      resendLoader: false,
      isDisabled: false
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    handleOnComplete(value) {
      console.log("OTP completed: ", value);
      this.OTP = value;
      if (value.length > 5) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
    },
    handleOnChange(value) {
      this.OTP = value;

      if (value.length > 5) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
    },
    async submitOTP(e) {
      e.preventDefault();
      console.log("lengf", this.OTP);
      const HTTP = this.$httpUtils.FASTHTTP;

      const dataDend = {
        verificationtoken: this.OTP,
        email: this.data.email
      };

      try {
        this.submitLoader = true;
        let res = await HTTP.post(`/auth/verifyemail-otp`, dataDend)
          .then(res => {
            if (res.status == 204) {
              this.showSuccessMsg({
                message: "Email has been verified!"
              });
              this.submitLoader = false;

              // HTTP.post(
              //   "/onboardingNotifications/sendAccountRegistrationEmail",
              //   {
              //     firstName: this.data.firstName,
              //     lastName: this.data.lastName,
              //     email: this.data.email,
              //     customerId: this.data.id
              //   }
              // );
              setTimeout(() => {
                router.push("/auth/login");
              }, 2000);
            }
          })
          .catch(error => {
            console.log("error in", error);
            const message = error.response.data.detail;
            this.showErrorMsg({ message: JSON.stringify(message) });
            this.submitLoader = false;
          });
      } catch (error) {
        console.log("error out", error);
        this.errorMessage = "Something went wrong, please try again.";
        this.showErrorMsg({ message: this.errorMessage });
        this.submitLoader = false;
      }
    },
    async resendOTP(e) {
      e.preventDefault();
      const HTTP = this.$httpUtils.FASTHTTP;

      try {
        this.resendLoader = true;

        const idata = {
          email: this.data.email
        };
        console.log(idata);

        let res = await HTTP.post("/auth/resend-token", idata)
          .then(res => {
            if (res.status == 204) {
              this.showSuccessMsg({
                message: "OTP has been resent!"
              });
              this.resendLoader = false;
            }
          })
          .catch(error => {
            console.log("error in", error);
            let { response } = error;
            let { message } = response.data.error;
            this.showErrorMsg({ message: message.split(";")[0] });
            this.resendLoader = false;
            console.log("first", this.showErrorMsg);
          });
      } catch (error) {
        console.log("error out", error);
        this.errorMessage = "Something went wrong, please try again.";
        this.showErrorMsg({ message: this.errorMessage });
        this.resendLoader = false;
        console.log("second", this.showErrorMsg);
      }
    }
  },
  mounted() {
    this.data = this.$route.params;
  }
};
</script>

<style lang="scss">
.modal-body {
  width: 676px;
  margin: 105px auto;
  padding: 45px;
  background: #ffffff;
  box-shadow: 0px 6px 4px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  font-family: "DM Sans";
  display: flex;
  flex-direction: column;
  align-items: center;
}

.modal-body p {
  font-family: inherit;
  font-weight: 700;
  font-size: 24px;
  line-height: 39px;
}

.image {
  margin: 36px auto;
}

.logo {
  width: 155px;
}

b {
  font-weight: bold;
  font-family: inherit;
}

.submit {
  display: flex;
  margin: auto;
}

.submit-button {
  background: #0892d0;
  border-radius: 5px;
  width: 150px;
  height: 51px;
  margin: 31px;
  border: none;
  font-family: inherit;
  font-size: 16px;
  line-height: 24px;
  color: #ffffff;
  cursor: pointer;
}

.form-button {
  padding: 0.875rem 3rem;
  border-radius: 5px;
  background-color: #0892d0;
  border: none;
  color: #ffffff;
  font-size: 16px;
  line-height: 24px;
  margin-top: 2.5rem;
  align-self: flex-end;
}

.submit-gif {
  color: #ffffff;
  text-align: center;
  border: 0;
  background-color: transparent;
}

.close {
  margin: 0px 0px 0px auto;
}

.text {
  width: 452px;
  font-family: inherit;
  font-size: 16px;
  text-align: center;
  color: #727272;
  line-height: 24px;
}

.max {
  background: rgba(233, 233, 233, 0.83);
}

.otp-input {
  width: 5rem;
  height: 4rem;
  padding: 5px;
  margin: 0 10px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid #0892d0;
  text-align: center;

  &.error {
    border: 1px solid red !important;
  }
}

@media (max-width: 1100px) {
  .modal-body {
    max-width: 95vw;
    margin: 30% auto;
    padding: 20px;
  }

  .text {
    width: 80vw;
    font-size: 13px;
    color: #727272;
    line-height: 20px;
  }

  .image {
    max-width: 130px;
  }

  .otp-input {
    width: 3rem;
    height: 3rem;
    padding: 3px;
    margin: 0 10px;
    font-size: 11px;
  }

  .submit-button {
    border-radius: 5px;
    width: 100px;
    height: 45px;
    font-size: 12px;
    line-height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/EmailVerified.vue